// extracted by mini-css-extract-plugin
export default {"button":"ScrollToTopButton_button__QGoPj"};